export function flicking() {
    $('.flicking--js').each(function () {
        let align = 'center';
        if ($(this).attr('data-align') === 'prev') align = 'prev';

        // Remove hidden slides from the DOM before initializing Flicking (otherwise Flicking calculates slides widths incorrectly)
        try {
            const camera = $(this).find('.flicking-camera');
            const hiddenSlides = camera.find('.slide[style*="display: none"]');
            hiddenSlides.remove();
        } catch (e) {
            console.error('[flicking--js] Error removing hidden slides:', e);
        }

        const flicking = new Flicking(this, {
            // moveType: "freeScroll",
            preventDefaultOnDrag: true,
            align,
            bound: true,
            bounce: 0,
            inputType: ['pointer'],
        });

        const resize = () => {
            try {
                flicking.resize();
            } catch (e) {
                console.error('[flicking--js] Error resizing:', e);
            }
        };

        $(this).find('img').on('load', resize);
        if (document.readyState === 'complete') {
            resize();
        } else {
            window.addEventListener('load', resize, { once: true });
        }
    });
}
